import { Link } from "react-router";
import type { Agent } from "../lib/queries";
import { agentStage } from "../lib/model";
import { pad, usdc } from "../lib/format";
import { Sigil, LiveDot } from "./ui";

export function AgentCard({ agent }: { agent: Agent }) {
  const stage = agentStage(agent);
  const displayName = agent.metadataComplete && agent.name ? agent.name : "Metadata incomplete";
  return <Link to={`/agents/${agent.agentId}`} className="agent-card panel hud">
    <div className="screen"><div className="screen-top"><span>Registry V2 purchase</span><LiveDot live={false} label="ON-CHAIN" /></div><div className="screen-text"><div className="clamp-2">{agent.promptDisplayText ?? "Prompt display unavailable"}</div></div></div>
    <div className="body">
      <div className="agent-id"><Sigil id={agent.agentId} size={52} /><div><div className="name truncate">{displayName}</div><div className="small muted">#{pad(agent.agentId)} · tier {agent.tierId}</div></div></div>
      <div className="mini-stats"><div><div className="label">Paid</div><div className="v">{usdc(agent.price)}</div></div><div><div className="label">Prompt</div><div className="v">{agent.promptFinalized ? `${agent.promptChunksReceived}/${agent.promptChunks}` : `${agent.promptChunksReceived}/${agent.promptChunks}`}</div></div><div><div className="label">Phase</div><div className="v">{agent.phase}</div></div></div>
      <div className="spread small muted"><span>{stage.label}</span><span>creator {agent.creator.slice(0, 8)}…</span></div>
    </div>
  </Link>;
}
